import React from 'react';
import { Link } from 'react-router-dom';

import { DataText } from 'src/UIComponents';
import { useAnythings } from 'src/queries/anything';

const MAX_LENGTH = 30;

function AnythingItem({ value: item }) {
  let formattedValue1 = item.value1;
  if (item.value1.length > MAX_LENGTH) {
    formattedValue1 = `${item.value1.substring(0, MAX_LENGTH)}...`;
  }
  let formattedValue2 = item.value2;
  if (item.value2.length > MAX_LENGTH) {
    formattedValue2 = `${item.value2.substring(0, MAX_LENGTH)}...`;
  }
  return (
    <tr>
      <td>
        <Link to={`/anythings/${item.id}`}>{item.type}</Link>
      </td>
      <td>
        <DataText>{formattedValue1}</DataText>
      </td>
      <td>
        <DataText>{formattedValue2}</DataText>
      </td>
    </tr>
  );
}

function AnythingsList({ ...rest }) {
  const { isLoading, data: anythings = [] } = useAnythings({
    sort_by: 'createdAt.desc',
    limit: 10,
  });

  if (isLoading) {
    return null;
  }
  return (
    <div {...rest}>
      <table className="u-full-width">
        <thead>
          <tr>
            <th width="25%">Type</th>
            <th width="40%">Value #1</th>
            <th width="35%">Value #2</th>
          </tr>
        </thead>
        <tbody>
          {anythings.map((anything) => (
            <AnythingItem key={`anything${anything.id}`} value={anything} />
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default AnythingsList;
